// ============================================================================
// page-project / projects.js
// ----------------------------------------------------------------------------
// "Other Projects" — center-aligned Flickity strip with wrap-around and
// external prev/next arrows. Directional hover on the cards is auto-bound
// globally by directional-hover.js.
// ============================================================================

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const sliderEl = document.querySelector(".service-projects__card");
  if (!sliderEl) return;

  sliderEl.style.display = "block";

  const instances = initCarousels(".service-projects__card", {
    cellAlign: "center",
    contain: false,
    pageDots: false,
    wrapAround: true,
    imagesLoaded: true,
  });
  if (!instances || !instances.length) return;
  const flkty = instances[0].flickity;

  const prev = document.querySelector(".service-projects__nav-button.prev");
  const next = document.querySelector(".service-projects__nav-button.next");
  if (prev)
    prev.addEventListener("click", function () {
      flkty.previous();
    });
  if (next)
    next.addEventListener("click", function () {
      flkty.next();
    });
});
